import { useDisclosure } from '@chakra-ui/react';
import * as React from 'react';

import { EPromptState, LogInSignUpModal } from '@/components/LogInSignUp';
import { useCurrent } from '@/hooks/useCurrent';

// dont use this anymore
export const useSignUpPrompt = (options?: {
  initialPromptState?: EPromptState;
  conference?: {
    useConferenceHeaders: boolean;
    name: string;
  };
}): {
  promptModal: React.ReactNode;
  showPrompt: () => void;
  showPromptWithIntercept: (
    e: React.MouseEvent,
    skip?: (userId: string | null) => boolean
  ) => void;
  // call originalOnClick if we have a user, otherwise open promptModal
  withPrompt: (originalOnClick: () => void) => () => void;
  loading: boolean;
} => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const current = useCurrent();

  const promptModal = (
    <LogInSignUpModal
      isOpen={isOpen}
      onClose={() => onClose()}
      initialPromptState={options && options.initialPromptState}
      conference={options && options.conference}
    />
  );

  const showPrompt = (): void => onOpen();

  const withPrompt = (originalOnClick: () => void): (() => void) => {
    return () => {
      if (current.loading) return;
      if (!current.user?._id) {
        showPrompt();
        return;
      }
      originalOnClick();
    };
  };

  const showPromptWithIntercept = (
    e: React.MouseEvent<HTMLAnchorElement>,
    skip?: (userId: string | null) => boolean
  ): void => {
    e.stopPropagation();
    if (skip && skip(!!current.user?._id ? current.user._id : null)) {
      return;
    }
    e.preventDefault();
    e.nativeEvent.stopImmediatePropagation();
    showPrompt();
  };

  return {
    promptModal,
    showPrompt,
    withPrompt,
    showPromptWithIntercept,
    loading: current.loading,
  };
};
